import { StringNode, widget, WidgetPlugin } from '@sagold/react-json-editor';

import { FormField } from '../../../components/formfield/FormField';
import { MonthPicker } from '../../../components/period-picker/MonthPicker';
import { formValueToPeriodPickerValue } from '../../../components/period-picker/periodRange';
import { ReadOnlyInput } from '../../../components/readonly-input/ReadOnlyInput';
import { PeriodPickerWidgetOptions } from '../periodPickerWidgetOptions';
import { useErrorTransformation } from '../widgetUtils';

export const MonthPickerWidget = widget<
  StringNode<PeriodPickerWidgetOptions>,
  string | null
>(({ node, options, setValue }) => {
  const errors = useErrorTransformation(node.errors);
  const hasError = node.errors.length > 0;
  const showError = options.showErrorWithColor || options.showErrors !== false;

  return (
    <FormField
      widgetType="select"
      node={node}
      errors={errors}
      options={options}
      tableLayout={options.tableLayout}
    >
      {options.readOnly ? (
        <ReadOnlyInput
          description={options.description}
          value={node.value}
          placeholder={options.placeholder}
          label={options.title}
          tableLayout={options.tableLayout}
          hasError={options.showErrorWithColor && hasError}
        />
      ) : (
        <MonthPicker
          value={formValueToPeriodPickerValue(node.value)}
          description={options.description}
          label={options.title}
          required={options.required}
          disabled={options.disabled}
          loading={options.loading}
          error={showError && hasError}
          clearable={options.clearable}
          boundary={options.boundary ?? 'end'}
          minDate={options.minDate}
          maxDate={options.maxDate}
          placeholder={options.placeholder}
          onChange={(value) => setValue(value ?? null)}
        />
      )}
    </FormField>
  );
});

export const MonthPickerWidgetPlugin: WidgetPlugin = {
  id: 'month-picker-widget',
  use: (node) =>
    node.schema.options?.widget === 'MonthPicker' &&
    node.schema.format === 'date',
  Widget: MonthPickerWidget,
};
